import styled from 'styled-components';

import { style } from '@genially/design-system';

/**
 * Below sm there is no width left to split: the columns stack and the panel scrolls the
 * whole read from the first section, the way the collapsed view already does. Flow rather
 * than grid so every box keeps its own height instead of being squeezed into a track.
 */
export const stackedOnMobile = style.mixins.responsive.sm.downward({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
});

/** The full-screen layout both expanded views share: the session's and a question's. */
export const Columns = styled.div(({ theme: { size } }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1fr)',
  // The single row is pinned to the stage instead of being sized by its tallest column: an
  // auto row grows past the panel, and the rest of a long list is then clipped off the
  // bottom of the screen with nothing to scroll. Bounded, the lists scroll inside.
  gridTemplateRows: 'minmax(0, 1fr)',
  gap: size.units(4),
  flex: 1,
  minHeight: 0,

  ...stackedOnMobile,
}));

export const Column = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: size.units(2),
  minHeight: 0,

  // Stacked, a column is as tall as what it holds: nothing shrinks it into an inner
  // scroll, so the lists and the chart stay whole and the panel does the scrolling.
  ...style.mixins.responsive.sm.downward({
    flexShrink: 0,
  }),
}));
